<template>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M19,16.0001C13.4772,16.0001,9,11.5228,9,6c0-1.3221,0.2566-2.5842,0.7225-3.7394
    C5.297,3.2913,2,7.2607,2,12c0,5.5228,4.4772,10.0001,10,10.0001c4.2008,0,7.7968-2.5904,9.2775-6.2607
    C20.546,15.9099,19.7836,16.0001,19,16.0001z"/>
</template>

<script>
export default {
  name: 'ClearNight'
}
</script>